export default "__VITE_ASSET__eWy3UYcf__"